import normalizePortfolio from "./normalizePortfolio";

/**
 * @param {Object} user
 *
 * @return {Object}
 */
export default function normalizeUser(user) {
  const portfolios = user.portfolios.map(normalizePortfolio);

  return {
    ...user,
    portfolios,
    fullName: `${user.first_name} ${user.last_name}`,
    currentPortfolio: portfolios.find(portfolio => portfolio.uid === user.default_portfolio_uid) || {}
  };
}
